import React from 'react'
import styles from './ClimbMetrics.scss'
import { formatDistance, formatSpeed, formatGrade } from 'lib/units'
import { useFormatMessage, commonNouns, commonMetrics } from 'lib/localization'
import _ from 'lodash'

export class ClimbMetrics extends React.Component {
  // throttle to a 1Hz update rate
  shouldComponentUpdate () {
    if (Date.now() < this._nextUpdate) {
      return false
    }
    this._nextUpdate = Date.now() + 1000
    return true
  }

  render () {
    const { progress, timeIndexed, metricUnits } = this.props
    // TODO update this to be timeIndexed
    const point = timeIndexed[Math.floor(timeIndexed.length * progress)]
    // problem: we don't have speed, grade, etc in track_points
    // problem: negative grades are way too large, I think the return value of atan is off
    return (
      <div className={styles.ClimbMetrics}>
        <Metric label={commonMetrics.speed} unit={formatSpeed(point.speed, { metricUnits, maximumFractionDigits: 1 })} />
        <Metric label={commonMetrics.grade} unit={formatGrade(point.grade, { metricUnits })} />
        <Metric label={commonNouns.elevation} unit={formatDistance(point.ele, { metricUnits, smallUnits: true })} />
        <Metric label={commonMetrics.distance} unit={formatDistance(point.distance, { metricUnits, bigUnits: true, maximumFractionDigits: 2 })} />
      </div>
    )
  }
}

const Metric = ({ unit, label }) => {
  const fm = useFormatMessage()
  return <div className={styles.Metric}>
    <h4 className={styles.metricLabel}>{_.lowerCase(fm(label))}</h4>
    <div className={styles.metricValue}>
      {Number.isFinite(unit.value) ? unit.valueToString() : '--'}
      <span className={styles.metricUnits}> {unit.short}</span>
    </div>
  </div>
}
